import { createElement, render } from "preact";
import { find } from "../dom/traverse";
import { extend } from "../extend";
import { parseElementAsJson } from "../json";
import { createUnstyledElement } from "../dom/manipulate";
export function mountJsxAndWrap(selector, mountable, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    elements.forEach(node => {
        const parent = node.parentElement;
        const componentContainer = createUnstyledElement("div", {
            class: "component-container",
        });
        if (null !== parent) {
            parent.insertBefore(componentContainer, node.nextSibling);
            componentContainer.appendChild(node);
            doMountJsx(node, mountable, options);
        }
    });
}
export function mountJsx(selector, mountable, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    elements.forEach(node => {
        doMountJsx(node, mountable, options);
    });
}
export function mountLazyJsx(selector, importer, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    if (!elements.length) {
        return;
    }
    importer().then(module => {
        elements.forEach(element => {
            doMountJsx(element, module.default, options);
        });
    }, error => console.error(`Mounting of component of path '${selector}' failed: ${error.message}`, error));
}
function doMountJsx(node, mountable, options) {
    options = options || {};
    let parent = node.parentElement;
    let params = (options.params || {});
    if (!parent) {
        console.error("Can't mount on container without parent.");
        return;
    }
    if (!options.hydrate) {
        params = extend(params, parseElementAsJson(node) || {});
        parent.removeChild(node);
    }
    render(createElement(mountable, params), parent, options.hydrate ? node : undefined);
}
export function mountClass(selector, mountable, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    elements.forEach(node => {
        doMountClass(node, mountable, options);
    });
}
export function mountLazyClass(selector, importer, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    if (!elements.length) {
        return;
    }
    importer().then(module => {
        elements.forEach(element => {
            doMountClass(element, module.default, options);
        });
    }, error => console.error(`Mounting of component of path '${selector}' failed: ${error.message}`, error));
}
function doMountClass(node, mountable, options) {
    options = options || {};
    const mounted = new mountable(node, ...(options.params || []));
    mounted.init();
}
export function mount(selector, mountable, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    elements.forEach(node => {
        doMountFunction(node, mountable, options);
    });
}
export function mountLazy(selector, importer, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    if (!elements.length) {
        return;
    }
    importer().then(module => {
        elements.forEach(element => {
            doMountFunction(element, module.default, options);
        });
    }, error => console.error(`Mounting of component of path '${selector}' failed: ${error.message}`, error));
}
function doMountFunction(node, mountable, options) {
    options = options || {};
    mountable(node, ...(options.params || []));
}
export function mountDataContainer(selector, mountable, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    elements.forEach(node => {
        doMountDataContainerFunction(node, mountable, options);
    });
}
export function mountLazyDataContainer(selector, importer, options) {
    let elements = typeof selector === "string" ? find(selector) : selector;
    if (!elements.length) {
        return;
    }
    importer().then(module => elements.forEach(element => doMountDataContainerFunction(element, module.default, options)), error => console.error(`Mounting of component of path '${selector}' failed: ${error.message}`, error));
}
function doMountDataContainerFunction(node, mountable, options) {
    let parent = node.parentElement;
    if (!parent) {
        console.error("Can't mount on container without parent.");
        return;
    }
    options = options || {};
    const params = (options.params || []);
    const parsedMountableConfig = (parseElementAsJson(node) || {});
    params.unshift(parsedMountableConfig);
    parent.removeChild(node);
    mountable(...params);
}
